import { Formik, FormikInsurance } from "src/types";
import {
  useResumePurchase,
  useResumePurchaseContent,
} from "./resume-purchase.hook";
import { Accordion, Button } from "src/ui/widgets";
import { RightArrowIcon } from "src/assets";
import { Image } from "react-bootstrap";
import { useState } from "react";

const ResumePurchaseContent = ({
  formik,
  continueDisabled,
  accordionMode = false,
}: {
  formik: Formik<FormikInsurance>;
  continueDisabled: boolean;
  accordionMode?: boolean;
}) => {
  const { policy, coverageTypeLabel, t, triggerFormikCheck } =
    useResumePurchase({
      formik,
    });

  const { resumePurchase, paymentMethodList } = useResumePurchaseContent({
    formik,
  });

  return (
    <>
      <div>
        {!accordionMode && (
          <div className="resume-purchase-coverage-type-tag">
            {coverageTypeLabel}
          </div>
        )}
        <div className="font-24-bold my-4">
          {t("data_entry.resume_purchase.title")}
        </div>
        {resumePurchase.map((item) => {
          return (
            <div
              key={item.key}
              className="resume-purchase-coverage-element d-flex justify-content-between"
            >
              <div>{item.key}</div>
              <div style={{ color: "var(--color-secondary)", fontWeight: 600 }}>
                {item.value}
              </div>
            </div>
          );
        })}
      </div>

      <div>
        <div className="font-14-ag-400 resume-purchase-coverage-element">
          {t("data_entry.resume_purchase.payment_modalities")}
          <div className="gap-2 d-flex flex-wrap mt-1">
            {paymentMethodList.map((src, index) => (
              <Image key={index} src={src} className={"mb-1"} height={"25px"} />
            ))}
          </div>
        </div>
        <div className="mt-2 d-flex justify-content-between align-items-center font-16-light">
          <div>{t("data_entry.resume_purchase.total")}</div>

          <div
            className="font-24"
            style={{ color: "var(--color-secondary)", fontWeight: 600 }}
          >
            {policy?.premioTotale !== undefined
              ? policy.premioTotale.toFixed(2).replace(".", ",")
              : "-"}{" "}
            €
          </div>
        </div>
        <div className="mt-3" onClick={(e) => e.stopPropagation()}>
          <Button
            type="button"
            text={t("commons.continue")}
            classes="primary d-flex justify-content-center button-submit m-md-0 w-100"
            classesText="font-medium-s text-uppercase"
            iconSize={20}
            iconRight={RightArrowIcon}
            disabled={continueDisabled}
            onPress={() => {
              formik.submitForm();
              triggerFormikCheck();
            }}
          />
        </div>
      </div>
    </>
  );
};

export const ResumePurchase = ({
  formik,
  continueDisabled,
}: {
  formik: Formik<FormikInsurance>;
  continueDisabled: boolean;
}) => {
  return (
    <div className=" resume-purchase-container d-flex flex-column justify-content-between">
      <ResumePurchaseContent
        formik={formik}
        continueDisabled={continueDisabled}
      />
    </div>
  );
};

export const ResumePurchaseAccordion = ({
  formik,
  continueDisabled,
}: {
  formik: Formik<FormikInsurance>;
  continueDisabled: boolean;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { policy, coverageTypeLabel, t, triggerFormikCheck } =
    useResumePurchase({
      formik,
    });

  const TotalContinue = (
    <div className="d-flex flex-row justify-content-between col align-items-center">
      <div className="d-flex flex-sm-row flex-column">
        <div className="me-5">{t("data_entry.resume_purchase.total")}</div>

        <div
          className="font-22-ag-400"
          style={{ color: "var(--color-secondary)", fontWeight: 600 }}
        >
          {policy?.premioTotale !== undefined
            ? policy.premioTotale.toFixed(2).replace(".", ",")
            : "-"}{" "}
          €
        </div>
      </div>
      <div className="justify-content-end" onClick={(e) => e.stopPropagation()}>
        <Button
          type="button"
          text={t("commons.continue")}
          classes="primary button-submit m-0"
          iconSize={20}
          iconRight={RightArrowIcon}
          disabled={continueDisabled}
          onPress={() => {
            formik.submitForm();
            triggerFormikCheck();
          }}
        />
      </div>
    </div>
  );

  const CoverageTypeLabel = (
    <div className="col">
      <div className="resume-purchase-coverage-type-tag">
        {coverageTypeLabel}
      </div>
    </div>
  );

  return (
    <Accordion
      classes="d-block d-xl-none"
      classesHead={`resume-purchase-accordion${isExpanded ? "--expanded" : ""}`}
      head={isExpanded ? CoverageTypeLabel : TotalContinue}
      arrowVersus="left"
      classesIcon="filter-00686F"
      iconContainerClass="resume-purchase-accordion--icon-container"
      onToggle={(isExpanded) => setIsExpanded(isExpanded)}
    >
      <div className="resume-purchase-container--accordion">
        <ResumePurchaseContent
          formik={formik}
          continueDisabled={continueDisabled}
          accordionMode
        />
      </div>
    </Accordion>
  );
};
